import React from 'react'
import TabView from '../components/TabView'

const MaterialTab = ({tab, data}) => <TabView tab={tab} data={data}/>

export default MaterialTab
